import React, { useEffect, useState } from "react";
import axios from "axios";
import { motion, AnimatePresence } from "framer-motion";
import { X, CalendarRange, ArrowRight } from "lucide-react";
import { usePlayerAuth } from "../context/PlayerAuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function MondayNudge({ suppress = false }) {
  const { token } = usePlayerAuth();
  const [open, setOpen] = useState(false);
  const [tipTitle, setTipTitle] = useState("");

  useEffect(() => {
    if (!token || suppress) return;
    let active = true;
    const t = setTimeout(async () => {
      try {
        const { data } = await axios.get(`${API}/weekly/nudge`, { headers: { Authorization: `Bearer ${token}` } });
        if (active && data?.show) { setTipTitle(data.tip_title || ""); setOpen(true); }
      } catch (e) { /* silent */ }
    }, 3800);
    return () => { active = false; clearTimeout(t); };
  }, [token, suppress]);

  const goToTraining = () => {
    setOpen(false);
    const el = document.getElementById("weekly-session");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          data-testid="monday-nudge"
          initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
          className="fixed inset-0 z-[60] flex items-center justify-center bg-black/70 backdrop-blur-sm p-4"
          onClick={() => setOpen(false)}>
          <motion.div
            initial={{ scale: 0.92, y: 20 }} animate={{ scale: 1, y: 0 }} exit={{ scale: 0.92, y: 20 }}
            transition={{ type: "spring", stiffness: 300, damping: 26 }}
            onClick={(e) => e.stopPropagation()}
            className="relative w-full max-w-md rounded-2xl border border-[#C41E24]/40 bg-gradient-to-b from-[#1a0e0f] to-[#141414] p-7 text-center overflow-hidden">
            <button data-testid="monday-nudge-close" onClick={() => setOpen(false)} aria-label="Close"
              className="absolute right-3 top-3 flex h-9 w-9 items-center justify-center rounded-sm text-white/40 hover:text-white transition-colors"><X size={18} /></button>
            <div className="mx-auto w-14 h-14 rounded-full bg-[#C41E24]/20 flex items-center justify-center mb-4">
              <CalendarRange size={26} className="text-[#C41E24]" />
            </div>
            <div className="text-[11px] font-bold uppercase tracking-[0.2em] text-[#C41E24] mb-1">New Week · New Session</div>
            <h2 className="font-headings text-2xl uppercase tracking-wide mb-2">This Week's Session Is Live</h2>
            <p className="text-sm text-white/60 mb-6">
              {tipTitle ? <>Coach Barker dropped a new tip — <b className="text-white/80">{tipTitle}</b> — plus 3 fresh drills. </> : "Coach Barker set 3 fresh drills for you this week. "}
              Complete all three to bank <b className="text-[#22C55E]">+5 bonus points</b>.
            </p>
            <button data-testid="monday-nudge-go" onClick={goToTraining}
              className="w-full flex items-center justify-center gap-2 bg-[#C41E24] hover:bg-[#A0161D] text-white font-subheadings font-bold uppercase tracking-wider px-6 py-3 rounded-sm transition-colors">
              Go To Training <ArrowRight size={16} />
            </button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
